<template>
  <Dialog :title="dialogTitle" v-model="dialogVisible" width="520px">
    <el-form
      ref="formRef"
      :model="formData"
      :rules="formRules"
      label-width="120px"
      v-loading="formLoading"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="门店名称" prop="name">
            <el-input v-model="formData.name" placeholder="请输入门店名称" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="核销会员" prop="verifyUserIds">
            <el-button type="primary" @click="storeMemberTableSelect.open(formData.verifyUsers)">
              选择会员
            </el-button>
            <!-- 旧：选择系统用户店员
            <el-button type="primary" @click="storeStaffTableSelect.open()">选择店员</el-button>
            -->
          </el-form-item>
          <ContentWrap v-if="formData.verifyUsers?.length > 0">
            <el-table :data="formData.verifyUsers">
              <el-table-column label="编号" align="center" prop="id" width="80" />
              <el-table-column
                label="会员昵称"
                align="center"
                prop="nickname"
                :show-overflow-tooltip="true"
              />
              <el-table-column label="手机号" align="center" prop="mobile" width="120" />
              <el-table-column label="状态" align="center" key="status" width="80">
                <template #default="scope">
                  <dict-tag :type="DICT_TYPE.COMMON_STATUS" :value="scope.row.status" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="80">
                <template #default="scope">
                  <el-button
                    v-hasPermi="['trade:delivery:pick-up-store:delete']"
                    link
                    type="danger"
                    @click="handleDelete(scope.row.id)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </ContentWrap>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button @click="submitForm" type="primary" :disabled="formLoading">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>

  <!-- 选择核销会员 -->
  <StoreMemberTableSelect ref="storeMemberTableSelect" @change="handleSelect" />
  <!-- 旧：选择系统用户
  <StoreStaffTableSelect ref="storeStaffTableSelect" @change="handleSelect" />
  -->
</template>
<script setup lang="ts">
import * as DeliveryPickUpStoreApi from '@/api/mall/trade/delivery/pickUpStore'
import StoreMemberTableSelect from './components/StoreMemberTableSelect.vue'
// import StoreStaffTableSelect from './components/StoreStaffTableSelect.vue'
import { DICT_TYPE } from '@/utils/dict'
import type { UserVO } from '@/api/member/user'

const message = useMessage()

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formData = ref({
  id: undefined as number | undefined,
  name: '',
  verifyUsers: [] as UserVO[]
})
const formRules = reactive({})
const formRef = ref()
const storeMemberTableSelect = ref()
// const storeStaffTableSelect = ref()

/** 打开弹窗 */
const open = async (id: number) => {
  dialogVisible.value = true
  dialogTitle.value = '绑定自提核销会员'
  resetForm()
  formLoading.value = true
  try {
    const data = await DeliveryPickUpStoreApi.getDeliveryPickUpStore(id)
    formData.value = {
      id: data.id,
      name: data.name,
      verifyUsers: (data.verifyUsers || []).map((item: any) => ({
        id: item.id,
        nickname: item.nickname,
        avatar: item.avatar,
        status: item.status,
        mobile: item.mobile
      }))
    }
  } finally {
    formLoading.value = false
  }
}
defineExpose({ open })

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data: DeliveryPickUpStoreApi.DeliveryPickUpStoreBindReqVO = {
      id: formData.value.id!,
      verifyUserIds: formData.value.verifyUsers.map((item) => item.id!)
    }
    await DeliveryPickUpStoreApi.bindStoreStaffId(data)
    message.success('绑定成功')
    dialogVisible.value = false
  } finally {
    formLoading.value = false
  }
}

const handleSelect = (checkedUsers: UserVO[]) => {
  formData.value.verifyUsers = checkedUsers
}

const handleDelete = async (id: number) => {
  const index = formData.value.verifyUsers.findIndex((item) => item.id === id)
  if (index > -1) {
    formData.value.verifyUsers.splice(index, 1)
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    name: '',
    verifyUsers: []
  }
  formRef.value?.resetFields()
}
</script>
